import ScrollMixin from '@/mixins/ScrollMixin'
import SafariMixin from '@/mixins/SafariMixin'
export default {
  name: 'start',
  components: {},
  props: [],
  mixins: [ScrollMixin,SafariMixin],
  data () {
    return {
      mainElementId: 'main',
      offseterId: 'offseter',
      numSlides: 2,
      minTitleScroll: window.innerWidth
    }
  },
  computed: {

  },
  mounted () {
    if (this.$route.hash == '#historias') {
      $(this.mainWrapper).animate({
        scrollLeft: window.innerWidth
      }, 0)
    } else if (this.$route.hash == '#welcome') {
      $(this.mainWrapper).animate({
        scrollLeft: 0
      }, 0)
    }
  },
  methods: {
    goToStart() {
      $(this.mainWrapper).animate({
        scrollLeft: 0
      }, 0)
    }
  }
}


